const set_timezone = (data) => {
  return {
    type: "SET_TIMEZONE",
    data: data,
  };
};

export default { set_timezone };
